import { CompareCancerQuoteParams } from '@apis/CancerQuoteApi';
import { getRoute } from '@utils/route';

export type CancerQuoteComparePageParams = CompareCancerQuoteParams

export const CANCER_QUOTE_COMPARE_PAGE_URL = '/cancer-insurance-quote-compare';

export const routeCancerQuoteComparePage = (searchParams: CancerQuoteComparePageParams) => getRoute(CANCER_QUOTE_COMPARE_PAGE_URL, { searchParams });
